





























































import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {
  defineComponent,
  ref,
  computed,
  useContext
} from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const value = ref(false)
    const { name } = props
    const { app } = useContext()
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))
    const isEn = computed(() => app.i18n.locale === 'en')
    const onValue = (v: Ref<any>) => {
      value.value = v.value
    }

    const { valueChanged, error } = useClassifiedForm(props, { onValue })

    const handleCheckboxChange = (onlyTrades: boolean) => {
      valueChanged(name, onlyTrades)
      error.value = null
    }

    return {
      value,
      handleCheckboxChange,
      info: faInfoCircle,
      error,
      isEn,
      isSingleOrAnon
    }
  }
})
